import { Button, Input, message, Modal } from "antd";
import { useEffect, useRef } from "react";

const EditItemDetails = ({
  itemDetailsOpen,
  setItemDetailsOpen,
  setItemDetailsData,
  itemDetailsData,
  itemDesignCode,
  setBarCodeData,
  barCodeData,
  qtyData,
  offerARate,
  offerBRate,
  adminType,
}) => {
  const inputRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setItemDetailsOpen(false);
  };
  useEffect(() => {
    if (itemDetailsOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [itemDetailsOpen]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };
  const maxQty1 =
    qtyData?.find((q) => q.DesignCode === itemDetailsData?.DesignCode)?.Qty ??
    0;
  return (
    <Modal
      className="ei-modal"
      title={<div className="ei-title">Product Details</div>}
      open={itemDetailsOpen}
      onCancel={handelCancel}
      closable={false}
      onOk={handelCancel}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .ei-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .ei-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .ei-modal .ant-modal-body{padding:14px;background:#eef1f8}

        .ei-title{background:linear-gradient(135deg,#114a3d,#1f8f6a);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .ei-head{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 4px 12px rgba(22,37,102,.3)}
        .ei-head-top{display:flex;align-items:center;justify-content:space-between;gap:10px}
        .ei-head-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.85}
        .ei-chip{background:linear-gradient(180deg,#ffd666,#f2b01e);color:#3b2a00;font-weight:800;font-size:17px;padding:4px 14px;border-radius:10px}
        .ei-pname{margin-top:8px;font-size:13px;font-weight:700;color:#e6ebff;word-break:break-word}

        .ei-qtycard{margin-top:10px;background:#fff;border:2px solid #52bd91;border-radius:14px;padding:8px 12px 10px;box-shadow:0 3px 10px rgba(82,189,145,.25)}
        .ei-label{font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
        .ei-qty{height:46px;border-radius:10px!important;font-size:22px;font-weight:800;color:#162566;width:100%}

        .ei-grid{margin-top:10px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px}
        .ei-card{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 10px 10px}
        .ei-inp{height:38px;border-radius:10px!important;font-size:15px;font-weight:700;color:#162566;width:100%}
        .ei-inp.ant-input-disabled,.ei-inp[disabled]{background:#f4f7fd!important;color:#162566!important}

        .ei-result{margin-top:10px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .ei-tile{border-radius:14px;padding:10px 12px;color:#fff}
        .ei-tile.act{background:linear-gradient(135deg,#ffb020,#f08a00)}
        .ei-tile.amt{background:linear-gradient(135deg,#1f8f6a,#52bd91)}
        .ei-tile-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.9}
        .ei-tile-v{font-size:20px;font-weight:800;margin-top:2px}

        .ei-offer{margin-top:10px;background:linear-gradient(135deg,#003161,#0b4a8f);border-radius:14px;padding:8px 12px;color:#fff}
        .ei-offer-h{font-size:11px;font-weight:800;text-transform:uppercase;opacity:.85;margin-bottom:4px;letter-spacing:.5px}
        .ei-slab{display:flex;align-items:center;justify-content:space-between;padding:6px 0;border-top:1px dashed rgba(255,255,255,.25);font-size:13px;font-weight:700}
        .ei-slab:first-of-type{border-top:0}
        .ei-slab b{color:#ffd666;font-size:15px}

        .ei-actions{margin-top:12px}
        .ei-btn{width:100%;height:46px!important;border-radius:12px!important;font-weight:800!important;font-size:15px!important;background:linear-gradient(135deg,#1f8f6a,#52bd91)!important;border:0!important;color:#fff!important}
      `}</style>

      {/* Design code + product name (read-only) */}
      <div className="ei-head">
        <div className="ei-head-top">
          <span className="ei-head-l">Design Code</span>
          <span className="ei-chip">{itemDetailsData?.DesignCode || "-"}</span>
        </div>
        <div className="ei-pname">{itemDetailsData?.ProdName}</div>
      </div>

      {/* Qty */}
      <div className="ei-qtycard">
        <div className="ei-label">Qty</div>
        <Input
          placeholder="Enter Qty"
          className="ei-qty"
          ref={inputRef}
          inputMode="decimal"
          value={itemDetailsData?.stock ?? ""}
          onFocus={(e) => e.target.select()}
          onChange={(e) => {
            const val = e.target.value;

            if (!/^\d*\.?\d{0,2}$/.test(val)) return;

            const qty = Number(val);

            // 🔍 Calculate total existing stock for this DesignCode
            const totalExistingStock = barCodeData
              .filter(
                (item) => item.DesignCode === itemDetailsData?.DesignCode,
              )
              .reduce((sum, item) => sum + Number(item.stock || 0), 0);

            // 👉 subtract current editing row stock
            const currentRowStock = Number(
              barCodeData[itemDesignCode]?.stock || 0,
            );

            const adjustedTotal = totalExistingStock - currentRowStock;

            // ❌ Prevent exceeding maxQty1
            if (qty + adjustedTotal > maxQty1) {
              message.error(
                `Qty limit reached for ${itemDetailsData?.DesignCode}`,
              );
              return;
            }

            // ===============================
            // SMODEL A
            // ===============================
            if (itemDetailsData?.SMODEL === "A") {
              const maxOfferQty = 3;
              if (qty > maxOfferQty) return;

              const rate = Number(offerARate) || 0;

              const oQty =
                qty === 2 ? itemDetailsData?.OQTY2 : itemDetailsData?.OQTY3;

              const rateValue = qty > 0 ? (oQty || 0) / qty : 0;

              const price = qty === 1 ? rate : rateValue;

              setBarCodeData((prev) =>
                prev.map((item, index) =>
                  index === itemDesignCode
                    ? {
                      ...item,
                      stock: qty,
                      CPrice: price,
                      offer: price,
                    }
                    : item,
                ),
              );

              setItemDetailsData((prev) => ({
                ...prev,
                stock: qty,
                CPrice: price,
                offer: price,
              }));
            }

            // ===============================
            // SMODEL B
            // ===============================
            else if (itemDetailsData?.SMODEL === "B") {
              const maxQty = 3;
              if (qty > maxQty) return;

              const rateValue = Number(itemDetailsData?.CPrice) || 0;
              const rate = Number(offerBRate) || 0;

              const oQty =
                qty === 2 ? itemDetailsData?.OQTY2 : itemDetailsData?.OQTY3;

              const disPer = qty === 1 ? rate : oQty || 0;
              const disAmt = (rateValue * disPer) / 100;
              const actRate = rateValue - disAmt;

              setBarCodeData((prev) =>
                prev.map((item, index) =>
                  index === itemDesignCode
                    ? {
                      ...item,
                      stock: qty,
                      Disper: disPer,
                      Disamt: disAmt,
                      CPrice: rateValue,
                      offer: actRate,
                    }
                    : item,
                ),
              );

              setItemDetailsData((prev) => ({
                ...prev,
                stock: qty,
                Disper: disPer,
                Disamt: disAmt,
                CPrice: rateValue,
                offer: actRate,
              }));
            }

            // ===============================
            // NORMAL MODEL
            // ===============================
            else {
              setBarCodeData((prev) =>
                prev.map((item, index) =>
                  index === itemDesignCode ? { ...item, stock: qty } : item,
                ),
              );

              setItemDetailsData((prev) => ({
                ...prev,
                stock: qty,
              }));
            }
          }}
          onKeyDown={(e) => {
            if (
              itemDetailsData?.SMODEL === "A" ||
              itemDetailsData?.SMODEL === "B"
            ) {
              handleKeyDown(e, saveRef);
            } else {
              handleKeyDown(e, rateRef);
            }
          }}
        />
      </div>

      {/* Rate / Dis Per / Dis Amt */}
      <div className="ei-grid">
        <div className="ei-card">
          <div className="ei-label">Rate</div>
          <Input
            placeholder="Enter Rate"
            className="ei-inp"
            inputMode="decimal"
            disabled={
              itemDetailsData?.SMODEL === "A" ||
              itemDetailsData?.SMODEL === "B" ||
              adminType !== "ADMIN"
            }
            ref={rateRef}
            value={itemDetailsData?.CPrice ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const disPer = itemDetailsData?.Disper;
                const rateValue = val * disPer;
                const disAmt = rateValue / 100;
                const ActRate = val - disAmt;

                setBarCodeData((prev) =>
                  prev.map((item, index) =>
                    index === itemDesignCode
                      ? {
                        ...item,
                        CPrice: val,
                        Disamt: disAmt,
                        offer: ActRate,
                      }
                      : item,
                  ),
                );
                setItemDetailsData((prev) => ({
                  ...prev,
                  CPrice: val,
                  Disamt: disAmt,
                  offer: ActRate,
                }));
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disPerRef);
            }}
          />
        </div>

        <div className="ei-card">
          <div className="ei-label">Dis %</div>
          <Input
            placeholder="Enter Dis Per"
            className="ei-inp"
            inputMode="decimal"
            disabled={
              itemDetailsData?.SMODEL === "A" ||
              itemDetailsData?.SMODEL === "B" ||
              adminType !== "ADMIN"
            }
            ref={disPerRef}
            value={itemDetailsData?.Disper ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (!/^\d*\.?\d*$/.test(val)) return;
              const updatedValue = val === 0 ? 0 : Number(val);
              const rate = itemDetailsData?.CPrice;
              const rateValue = rate * val;
              const disAmt = rateValue / 100;
              const ActRate = rate - disAmt;

              setBarCodeData((prev) =>
                prev.map((item, index) =>
                  index === itemDesignCode
                    ? {
                      ...item,
                      Disper: updatedValue,
                      Disamt: disAmt,
                      offer: ActRate,
                    }
                    : item,
                ),
              );
              setItemDetailsData((prev) => ({
                ...prev,
                Disper: updatedValue,
                Disamt: disAmt,
                offer: ActRate,
              }));
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disAmtRef);
            }}
          />
        </div>

        <div className="ei-card">
          <div className="ei-label">Dis Amt</div>
          <Input
            placeholder="Enter Dis Amt"
            className="ei-inp"
            inputMode="decimal"
            disabled={
              itemDetailsData?.SMODEL === "A" ||
              itemDetailsData?.SMODEL === "B" ||
              adminType !== "ADMIN"
            }
            ref={disAmtRef}
            value={itemDetailsData?.Disamt ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const rate = itemDetailsData?.CPrice;
                const ActRate = rate - val;

                setBarCodeData((prev) =>
                  prev.map((item, index) =>
                    index === itemDesignCode
                      ? { ...item, Disamt: val, offer: ActRate }
                      : item,
                  ),
                );
                setItemDetailsData((prev) => ({
                  ...prev,
                  Disamt: val,
                  offer: ActRate,
                }));
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, saveRef);
            }}
          />
        </div>
      </div>

      {/* Act Rate / Amount (read-only) */}
      <div className="ei-result">
        <div className="ei-tile act">
          <div className="ei-tile-l">Act Rate</div>
          <div className="ei-tile-v">
            {Number(itemDetailsData?.offer)?.toFixed(2)}
          </div>
        </div>
        <div className="ei-tile amt">
          <div className="ei-tile-l">Amount</div>
          <div className="ei-tile-v">
            {Number(itemDetailsData?.stock * itemDetailsData?.offer)?.toFixed(
              2,
            )}
          </div>
        </div>
      </div>

      {/* Offer slabs */}
      {itemDetailsData?.SMODEL === "A" ? (
        <div className="ei-offer">
          <div className="ei-offer-h">Offer A</div>
          <div className="ei-slab">
            <span>BUY QTY : 1</span>
            <b>@ {offerARate}/-</b>
          </div>
          <div className="ei-slab">
            <span>BUY QTY : 2</span>
            <b>@ {itemDetailsData?.OQTY2}/-</b>
          </div>
          <div className="ei-slab">
            <span>BUY QTY : 3</span>
            <b>@ {itemDetailsData?.OQTY3}/-</b>
          </div>
        </div>
      ) : itemDetailsData?.SMODEL === "B" ? (
        <div className="ei-offer">
          <div className="ei-offer-h">Offer B</div>
          <div className="ei-slab">
            <span>BUY QTY : 1</span>
            <b>@ {offerBRate}%</b>
          </div>
          <div className="ei-slab">
            <span>BUY QTY : 2</span>
            <b>@ {itemDetailsData?.OQTY2}%</b>
          </div>
          <div className="ei-slab">
            <span>BUY QTY : 3</span>
            <b>@ {itemDetailsData?.OQTY3}%</b>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* Save */}
      <div className="ei-actions">
        <Button
          type="primary"
          className="ei-btn"
          ref={saveRef}
          onClick={() => {
            handelCancel();
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default EditItemDetails;